import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'
import jsonWebToken from 'Services/jsonWebToken'
import uuidv4 from 'uuid/v4'
import { stringify } from 'qs'
import { ApiQuoteOpportunityOptions, ApiResult, ApiResultList, ApiQuoteOpportunityPreview, ApiQuoteOpportunityDetail, ApiQuoteOpportunityExpired, ApiModalDiscard } from 'Types'

const endpoint = `${apiUrl.stable}/anunciante`

export const getOpportunityList = (page: number = 1, options: ApiQuoteOpportunityOptions = {}): ApiResultList<ApiQuoteOpportunityPreview> => {
  const url = `${endpoint}/oportunidade/geral`

  const paramsSerializer = params => stringify(params, { arrayFormat: 'repeat' })

  const params = {
    Page: page,
    ExceptIds: options.exclude || [],
    PageSize: options.pageSize || 5,
    SortType: options.sort,

  }

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers, params, paramsSerializer })
}

export const getOpportunityExpiredList = (): ApiResult<ApiQuoteOpportunityExpired[]> => {
  const url = `${endpoint}/oportunidade/expirada`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const getOpportunityDetails = (identifier: string): ApiResult<ApiQuoteOpportunityDetail> => {
  const url = `${endpoint}/oportunidade/detalhes/${identifier}`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const buyOpportunity = (quotationId: number) => {
  const url = `${endpoint}/comprar`

  const headers = { ...jsonWebToken.header }
  headers['x-requestid'] = uuidv4()

  return axios.post(url, { quotationId }, { headers })
}

export const discardOpportunity = (discardData: ApiModalDiscard) => {
  const url = `${endpoint}/oportunidade/descartar`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, discardData, { headers })
}

export const discardPublicOpportunity = (opportunityId: any) => {
  const url = `${endpoint}/oportunidade/${opportunityId}/descartar`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, null, { headers })
}

export default {
  getOpportunityList,
  getOpportunityDetails,
  buyOpportunity,
}